<template>
  <div style="background: #fff;">
 <div class="dianzan-box">
      <i :class="{ active: dianzanState }">+1</i>
      <img src="../assets/img/dianzhan.png" alt="" @click="dianzan" />
    </div>
    <div class="csTop" id="pageTop">
      <div class="bxBox">
        <div class="Logo">
          <img src="../assets/img/flogo.png" alt="">
        </div>
        <div class="topRight">
          <div class="Phone">服务热线：010-88810708</div>
          <a class="Fanh" href="http://demo.csz.emof.cn/web/"><img src="../assets/Template/fanhui.png" alt="">返回公益汇</a>
          <!--          <div class="tuichu"><img src="../assets/Template/tuichu.png" alt="">退出</div>-->
        </div>
      </div>
    </div>

    <div class="csNav">
      <div class="bx-Box">
        <div class="navLeft">
          <div >
            <img src="../assets/Template/Logo.png" alt="">
          </div>
          <p style="    flex: 1;line-height: 120%;">北京市社会组织孵化中心</p>
        </div>
      </div>
    </div>

    <div class="csBanner" id="pageInfo">
      <div class="BannerLeft">
        <img src="http://gyhfile.shzzfw.com/%E5%9F%BA%E5%9C%B0%E4%BB%8B%E7%BB%8D%E5%9B%BE%E7%89%87.jpg" alt="" >
      </div>
      <div class="Bannerright">
        <div>
          <p style="text-indent: 32px;">北京市社会组织孵化中心是由北京市委社会工委市民政局举办，北京市社会组织管理中心具体指导，委托北京公益服务发展促进会整体运营的全市社会组织孵化培育服务平台。中心为社会组织提供“党建引领、业务指导、咨询服务、培育扶持、能力提升、热点沙龙、场地管理”七大服务，多维度、多视角开展社会组织培育扶持工作，并以社会组织人才培育为核心，采用系统化ATS培育模式，为社会组织人才培育与创新发展提供持续性、专业化的支持和保障，从而健全社会组织内部治理，提升社会组织专业服务能力，推动社会组织有效有序参与社会治理并发挥更大作用，助力首都社会组织健康有序发展。</p>
          <div class="BannerBox">
            <div class="bannerBtn2" @click="telVisible = true">
              <img src="../assets/Template/yijiantonghua.png" alt="">一键通话
            </div>
            <div class="bannerBtn3" @click="codeVisible = true">
              <img src="../assets/Template/yijianzhuanfa.png" alt="">一键转发
            </div>
          </div>
        </div>

      </div>
    </div>



    <div class="csBottom" >
      <div class="bx" >
        <div class="fcTit">北京市社会组织孵化中心平台</div>
        <div class="fc-desc">
          <p>建立健全管理制度，加强入驻社会组织的规范化管理</p>
          <p>北京市社会组织孵化中心从整合与共享的视角出发，实现发展期社会组织创新加速的“一站式”服务，快速提升组织自身能力和服务水平；从系统与专业的视角出发，建立发展期社会组织能力评估指标体系，系统、规范、专业地开展评估，为加速服务工作提供有效依据；从实效与应用的视角出发，针对发展期社会组织的难点与问题，提供“定制式”的解决方案，提供“陪伴式”督导，使服务更加精准高效；从人才与发展的视角出发，针对发展期社会组织人才匮乏的问题，提供全方位的课程体系和系统化的培训体系，以推动社会组织快速成长。</p>
          <p>（一）建立健全管理制度，加强入驻社会组织的规范化管理</p>
          <p>通过《北京市社会组织孵化中心发展期社会组织创新加速项目管理办法》手册的发布，为入驻的社会组织在场地使用、会议室预约、准入与退出等日常管理工作提出了明确要求，使孵化中心的管理更加规范有序。</p>
          <p>（二）开展阶段性评估，提升孵化中心的精准化服务</p>
          <p>通过评估，孵化中心对社会组织的需求和问题有了更加精准的掌握，所提供的服务与社会组织需求更加匹配，进一步提升了孵化中心的服务品质和服务能力。
          <p>（三）采用多元化形式，提高孵化中心信息化管理水平</p>
          <p>在开通微信公众号平台的基础上，实现在线预约共享会议室、督导服务、资源对接、机构展示等，提高会议室使用率，形成孵化中心信息数据库，增强信息传播力度。</p>
          <p>（四）创新孵化培育模式，加大对社会组织的支持力度</p>
          <p>以全市社会组织发展情况和社会组织需求为导向，科学、合理设计适用于发展期社会组织的孵化培育计划，通过“导师制”等创新孵化方法，解决社会组织发展中遇到的共性问题与个性问题，全方位助力社会组织加速成长，支持与引导社会组织的可持续性发展。</p>
         <p>（五）研发社会组织人才培育的三大体系，助力社会组织健康可持续发展</p>
         <p>以“人”与“实务”为核心，围绕“人才促发展”理念，通过自主研发的三大体系，进一步提升社会组织人才培育的系统化和专业化，有效提高社会组织人才的专业能力和服务水平，从而促进发展期社会组织创新能力和加速发展能力的提升。</p>
          <p>（六）整合社会力量，搭建促进社会组织交流与合作的平台</p>
          <p>通过动员和整合社会力量，建立孵化中心与社会组织、社会组织与社区、社会组织与社会组织以及各级孵化平台，形成良好的“共建共治共享”通道，提高了北京市支持性社会组织的联动意识，完善了北京市发展期社会组织的沟通合作机制，对于发展期社会组织的自身建设与交流合作起到了巨大的推动作用。</p>
         <p>（七）共享创新加速成果，强化对社会组织优秀案例的宣传推广</p>
         <p>通过案例撰写培训和加速组织案例库建立，进一步提高社会组织的总结反思能力和案例撰写能力，同时，对发展期社会组织优秀案例进行宣传与推广，为更多的社会组织提供借鉴与参考。</p>

        </div>
        <div class="fcList">
          <div class="listRight">
            <div class="fcBox iconfont" >
              <el-image
                style="width: 383px; height: 192px"
                src="http://gyhfile.shzzfw.com/dr1.jpg"

                @click="showImg(0,1)"
              >
              </el-image>
              <p class="ovHide">党日活动-理论课合照</p>
            </div>
            <div class="fcBox iconfont" >
              <el-image
                style="width: 383px; height: 192px"
                src="http://gyhfile.shzzfw.com/dr2.jpg"

                @click="showImg(1,1)"
              >
              </el-image>
              <p class="ovHide">党日活动-模拟实践课合照</p>
            </div>
            <div class="fcBox2 iconfont" >
              <el-image
                style="width: 383px; height: 192px"
                src="http://gyhfile.shzzfw.com/dr3.jpg"
                fit="scale-down"
                @click="showImg(2,1)"
              >
              </el-image>
              <p class="ovHide">党日活动-线下督导 </p>
            </div>
            <div class="fcBox iconfont" >
              <el-image
                style="width: 383px; height: 192px"
                src="http://gyhfile.shzzfw.com/dr4.jpg"

                @click="showImg(3,1)"
              >
              </el-image>
              <p class="ovHide">党日活动-交流访问</p>
            </div>
            <div class="fcBox2 iconfont" >
              <el-image
                style="width: 383px; height: 192px"
                src="http://gyhfile.shzzfw.com/dr5.jpg"

                @click="showImg(4,1)"
              >
              </el-image>
              <p class="ovHide">党日活动-场地服务</p>
            </div>
          </div>
        </div>
      </div>

      <div class="bx" >
        <div class="fcTit">北京市社会组织孵化中心加速实验室</div>
        <div class="fc-desc">
          <p>北京公益服务发展促进会作为市孵中心运营方，2020年携手政府、高校、企业以及其他支持型组织跨界联动，以“人才与发展”为定位打造社会组织“加速实验室”，提供社会组织能力测评、业务咨询、辅导培训、精准督导等服务，提高社会组织专业能力、服务能力与发展能力，将组建由行业专家、实务督导和跨界大咖构成的强悍导师团，通过陪伴式服务帮助社会组织解决创新发展过程中遇到的难题，12个月深度加速赋能，体系化助力社会组织蜕变成长。</p>
          <p>截至目前，加速实验室完成评审工作并进行结果公示，共有6家社会组织（社会团体2家、基金会2家、民办非企业单位2家）进入加速实验室，同时，经评审会专委员建议，另有4家民办非企业单位将获得加速实验室支持；联合中国社会科学院完成优化、论证社会组织发展能力评价指标体系（900分），自评版本指标设计等工作。</p>

        </div>
        <div class="fcList">
          <div class="listRight">
            <div class="fcBox iconfont" >
              <el-image
                style="width: 383px; height: 192px"
                src="http://gyhfile.shzzfw.com/dr6.JPG"
                @click="showImg(0,2)"
              >
              </el-image>
            </div>
            <div class="fcBox iconfont" >
              <el-image
                style="width: 383px; height: 192px"
                src="http://gyhfile.shzzfw.com/dr7.jpg"
                @click="showImg(1,2)"
              >
              </el-image>
            </div>
          </div>
        </div>

      </div>

      <div class="bx" >
        <div class="fcTit">专业支持</div>
        <div class="fc-desc">
          <p>发展期社会组织人才培育体系以“人”与“实务”为核心，围绕“人才促发展”的理念，采用评估－培训－督导的系统式培育模式，通过分层级、分类别的专业化人才培育促进孵化和加速阶段的社会组织能力成长，并力争形成具有示范性、可持续性和可复制性模式。发展期社会组织人才培育体系包括发展期社会组织能力评价体系及发展期社会组织人才能力提升课程体系两个部分。</p>
        </div>
        <div class="imgList">
          <div>
            <img src="http://gyhfile.shzzfw.com/dr8.png" alt="">
            <p>体系建设基础</p>
          </div>
          <div>
            <img src="http://gyhfile.shzzfw.com/dr9.png" alt="">
            <p>发展期人才培育体系特点</p>
          </div>
          <div>
            <img src="http://gyhfile.shzzfw.com/dr10.png" alt="">
            <p>发展期人才培育体系组成</p>
          </div>
          <div>
            <img src="http://gyhfile.shzzfw.com/dr11.png" alt="">
            <p>发展期社会组织能力评价体系</p>
          </div>
          <div>
            <img src="http://gyhfile.shzzfw.com/dr12.png" alt="">
            <p>发展期社会组织人才能力提升课程体系</p>
          </div>
          <div>
            <img src="http://gyhfile.shzzfw.com/dr13.png" alt="">
            <p>发展期社会组织人才能力提升课程库</p>
          </div>
        </div>

      </div>



      <div class="csLianx" id="pageCall">
        <div class="lianxiTit"><img src="../assets/Template/lianxiwomen.png" alt=""></div>
        <div class="bx-Box">
          <div class="lianXLeft">
            <div class="lianXimg"><img src="../assets/Template/dianhua.png" alt=""></div>
            <p class="lianXtex">联系电话</p>
            <p class="lianXtex">010-65396188</p>
          </div>
          <div class="lianXRight">
            <div class="lianXimg"><img src="../assets/Template/dizhi.png" alt=""></div>
            <p class="lianXtex">基地地址</p>
            <p class="lianXtex">北京市工人体育场东路20号百富国际大厦B座西门6F</p>
          </div>
        </div>
      </div>

    </div>

    <div class="csFooter">
      <div class="bx-Box">
        <div class="footerLeft">
          <img src="../assets/img/flogo.png" alt="">
        </div>
        <div class="footerCen">
          <p>主办单位：北京市委社会工委市民政局</p>
          <p>执行单位：北京市社会组织管理中心 </p>
          <p>协办单位：北京市扶贫协作和支援合作工作领导小组办公室 中关村科技园区管理委员会 </p>
          <p>北京市妇女联合会 北京市红十字会 首都公益慈善联合会</p>
          <p>承办单位：北京知诚社会组织众扶发展促进会</p>

          <p>All Rights Reserved <a href="http://www.beian.gov.cn" style="color: #fff;">京ICP备17050284号-4</a></p>
        </div>
        <div class="footerRight">
          <div>
            <img src="../assets/Template/ewm.png" alt="">
            <p>众扶平台公众号</p>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="list.length>0"
      :title="list[showImgIndex].name"
      :visible.sync="centerDialogVisible"
      width="1000px"
      center>
      <div >
        <img :src="list[showImgIndex].url" alt=""
             style="width: 100%;
        height: 100%;
        vertical-align: top;
        object-fit: scale-down;">
      </div>

      <div style="width: 200px;margin: 20px auto;display: flex;align-items: center;justify-content: space-around;">
        <el-button @click="pre">上一张</el-button>
        <el-button @click="next">下一张</el-button>
      </div>
    </el-dialog>
<!--    <el-dialog-->
<!--      title="文字洽谈"-->
<!--      :visible.sync="negotiationVisible"-->
<!--      width="700px"-->
<!--      center>-->
<!--      <negotiation @submitOk="submitOk"/>-->
<!--    </el-dialog>-->
    <el-dialog
      title="一键转发"
      :visible.sync="codeVisible"
      width="700px"
      center>
      <codemode :url="'fhzx'"/>
    </el-dialog>
    <el-dialog
      title="一键通话"
      :visible.sync="telVisible"
      width="700px"
      center>
      <tel :name="'北京市社会组织孵化中心'" :tel="'010-65396188'" />
    </el-dialog>
  </div>

</template>

<script>
// import negotiation from '../components/negotiation'
import codemode from '../components/codemode'
import tel from '../components/tel'
export default {
  name: "shouye",
  components:{
    codemode,
    tel
  },
  data() {
    return {
      dianzanState: false,
      list:[],
      list1:[
          {
            name:'党日活动-理论课合照',
            url:'http://gyhfile.shzzfw.com/dr1.jpg'
          },
          {
            name:'党日活动-模拟实践课合照',
            url:'http://gyhfile.shzzfw.com/dr2.jpg'
          },
          {
            name:'党日活动-线下督导 ',
            url:'http://gyhfile.shzzfw.com/dr3.jpg'
          },
          {
            name:'党日活动-交流访问',
            url:'http://gyhfile.shzzfw.com/dr4.jpg'
          },{
            name:'党日活动-场地服务',
            url:'http://gyhfile.shzzfw.com/dr5.jpg'
          }
        ],
      list2:[
        {
          name:'',
          url:'http://gyhfile.shzzfw.com/dr6.JPG'
        },{
          name:'',
          url:'http://gyhfile.shzzfw.com/dr7.jpg'
        }
      ],
      negotiationVisible:false,
      codeVisible:false,
      telVisible:false,
      centerDialogVisible: false,
      showImgIndex: 0,
    }
  },
  created() {
this.$api.apiContent.dianzan2({
      type: '孵化中心',
      t_id: 0,
      op: 1,
    })
  },
  methods: {
    dianzan () {
      this.dianzanState = true
      setTimeout(() => {
        this.dianzanState = false
      }, 600)
      this.$api.apiContent.dianzan2({
        type: '孵化中心',
        t_id: 0,
        op: 2,
      })

    },
    pre() {
      this.showImgIndex--
      if (this.showImgIndex < 0) {
        this.showImgIndex = this.list.length - 1
      }
    },
    next() {
      this.showImgIndex++
      if (this.showImgIndex >= this.list.length) {
        this.showImgIndex = 0
      }
    },
    showImg(num,list) {
      this.centerDialogVisible = !this.centerDialogVisible
      this.showImgIndex = num
      if(list === 1){
        this.list = this.list1
      }else{
        this.list = this.list2
      }
    },

  }
}
</script>

<style scoped lang="scss">
.dianzan-box {
  z-index: 99;
  position: fixed;
  right: 0;
  top: 70%;
  cursor: pointer;
  i {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
    font-size: 16px;
    color: red;
    opacity: 0;
    transition: all 0.6s linear;
    &.active {
      top: -50px;
      opacity: 1;
      font-size: 36px;
    }
  }
}
.csTop {
  width: 100%;
  height: 80px;
  background: url("../assets/Template/topBGC_01.jpg") no-repeat top center;

  .bxBox {
    width: 1220px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .Logo {
      display: flex;
      height: 80px;
      justify-content: space-between;
      align-items: center;

      img {
        margin-right: 15px;
      }
    }

    .topRight {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      height: 80px;
      flex: 1;

      .Phone {
        font-size: 16px;
        color: #333333;
        margin-right: 20px;
      }

      .Fanh {
        width: 142px;
        height: 38px;
        background-color: #c70005;
        border-radius: 19px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #f0f2f7;
        font-size: 16px;
        cursor: pointer;
        margin-right: 20px;

        img {
          width: 22px;
          margin-right: 10px;
        }
      }

      .tuichu {
        width: 94px;
        height: 38px;
        background-color: #e5580b;
        border-radius: 19px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #f0f2f7;
        font-size: 16px;
        cursor: pointer;

        img {
          width: 16px;
          margin-right: 10px;
        }
      }
    }
  }
}

.csNav {
  width: 100%;
  height: 133px;
  background-color: #c70005;

  .navLeft {
    width: 700px;
    display: flex;
    height: 133px;
    justify-content: flex-start;
    align-items: center;
    font-size: 28px;
    font-weight: bold;
    color: #ffffff;

    div {
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 100px;
      height: 100px;
      border-radius: 100px;
      border: 1px solid #fff100;
      margin-right: 20px;
      overflow: hidden;

      img {
        width: 100px;
      }
    }

  }

  .navRight {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    a {
      font-size: 18px;
      color: #ffffff;
      margin-left: 30px;

      &.act {
        color: #fff100;
      }
    }
  }
}

.csBanner {
  width: 1220px;
  margin: 0 auto 30px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .BannerLeft {
    width: 451px;
    height: 395px;
    //border: solid 1px #eeeeee;

    img {
      width: 451px;
      height: 395px;
      object-fit: scale-down;
    }
  }

  .Bannerright {
    display: flex;
    align-items: center;
    width: 739px;
    min-height: 392px;
    border: solid 1px #eeeeee;
    padding: 12px 17px;

    p {
      font-size: 16px;
      color: #333333;
      width: 100%;
      line-height: 28px;
      overflow: hidden;
    }

    .BannerBox {
      width: 100%;
      display: flex;
      justify-content: space-around;
      margin-top: 40px;

      .bannerBtn1 {
        width: 215px;
        height: 50px;
        background-color: #c70005;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        font-size: 18px;

        img {
          margin-right: 8px;
        }
      }

      .bannerBtn2 {
        width: 215px;
        height: 50px;
        background-color: #007ac7;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        font-size: 18px;

        img {
          margin-right: 8px;
        }
      }

      .bannerBtn3 {
        width: 215px;
        height: 50px;
        background-color: #e5580b;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        color: #ffffff;
        font-size: 18px;

        img {
          margin-right: 8px;
        }
      }
    }
  }
}

.csXiangmu {
  width: 100%;
  padding: 80px 0;

  .xmTit {
    width: 100%;
    text-align: center;
  }

  .xmList {
    width: 100%;
    min-height: 216px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 33px;

    .xmBox {
      max-width: 383px;
      height: 280px;
      /*text-align: center;*/
      position: relative;
      overflow: hidden;
      margin-bottom: 20px;

      .img1 {
        width: 93px;
        position: absolute;
        top: -24px;
        right: -20px;
      }

      .img2 {
        width: 100%;
        height: 100%;
        vertical-align: top;
        object-fit: scale-down;
      }

      p {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 40px;
        background-color: #c70005;
        line-height: 41px;
        font-size: 20px;
        color: #ffffff;
        padding: 0 10px;
        text-align: center;
      }
    }
  }
}

.csBottom {
  width: 100%;
  background: url("../assets/Template/bottomBGc_03.jpg") repeat top center;
  padding-bottom: 50px;

  .fcTit {
    width: 100%;
    text-align: center;
    padding-top: 67px;
    font-size: 32px;
    font-weight: bold;
  }
  .fc-desc{
    margin-top: 30px;
    p{
      font-size: 18px;
      text-indent: 36px;
      line-height: 32px;
    }
  }
  .imgList{
    display: block;
    margin-top: 20px;
    div{
      margin-bottom: 30px;
      img{
        display: block;
        max-width: 100%;
        margin: 0 auto 15px;

      }
      p{
        font-size: 20px;
        font-weight: bold;
        text-align: center;
      }
    }
  }
  .fcList {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 35px;

    .listRight {
      flex: 1;
      margin-left: 30px;
      display: flex;
      justify-content: space-around;
      flex-wrap: wrap;
      align-content: center;


      .fcBox {
        width: 383px;
        height: 192px;
        margin-bottom: 20px;
        background-color: #f2f2f2;
        position: relative;

        p {
          width: 100%;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          line-height: 40px;
          position: absolute;
          bottom: 0;
        }
      }

      .fcBox2 {
        width: 383px;
        height: 192px;
        background-color: #f2f2f2;
        position: relative;

        p {
          width: 100%;
          height: 40px;
          background-color: rgba(0, 0, 0, 0.5);
          font-size: 20px;
          color: #ffffff;
          text-align: center;
          line-height: 40px;
          position: absolute;
          bottom: 0;
        }
      }
    }
  }

  .csLianx {
    width: 100%;
    padding-top: 90px;

    .lianxiTit {
      width: 100%;
      text-align: center;
      padding-bottom: 50px;
    }

    .lianXLeft {
      width: 631px;
      height: 199px;
      background-color: #ffffff;

      .lianXimg {
        width: 100%;
        text-align: center;
        padding-top: 33px;

        img {
          width: 70px;
        }
      }

      .lianXtex {
        width: 100%;
        text-align: center;
        color: #666666;
        font-size: 18px;
        padding-top: 15px;
      }
    }

    .lianXRight {
      width: 551px;
      height: 199px;
      background-color: #ffffff;

      .lianXimg {
        width: 100%;
        text-align: center;
        padding-top: 33px;

        img {
          width: 70px;
        }
      }

      .lianXtex {
        width: 100%;
        text-align: center;
        color: #666666;
        font-size: 18px;
        padding-top: 15px;
      }
    }
  }
}

.csFooter {
  width: 100%;
  height: 190px;
  background-color: #333333;

  .footerLeft {
    display: flex;
    height: 190px;
    justify-content: space-between;
    align-items: center;

    img {
      margin-right: 15px;
    }
  }

  .footerCen {
    flex: 1;
    padding-top: 30px;
    padding-bottom: 30px;
    padding-right: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    height: 190px;


    p {
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #ffffff;
      /*margin-top: 15px;*/
    }
  }

  .footerRight {
    width: 100px;
    height: 190px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    margin-right: 100px;

    p {
      width: 100%;
      text-align: center;
      padding-top: 10px;
      font-size: 14px;
      color: #ffffff;
    }
  }
}

.xiangmFab {
  width: 186px;
  height: 52px;
  background-color: #c70005;
  border-radius: 26px 0 0 26px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
  position: fixed;
  right: 0;
  top: 250px;
  cursor: pointer;

  img {
    margin-left: 30px;
    margin-right: 15px;
  }
}

.bx {
  width: 1220px;
  margin: 0 auto;
}

.bx-Box {
  width: 1220px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.more-btn {
  display: block;
  margin: 20px auto 0;
  font-size: 18px;
  background: #c70005;
  color: #fff;
}
</style>
